




import {Component, Mixins} from "vue-property-decorator";
import MessageView from "@/components/message/messageView.vue";
import Authority from "@/common/mixins/authority";
@Component({
  name: "MessagePage",
  components: {
    MessageView,
  },
})
export default class MessagePage extends Mixins(Authority) {
  public singleRoom = true;
  public height = 'calc(100vh - 50px)';
}
